module.exports = __webpack_public_path__ + "static/media/project-4.8bb9c700.jpg";